var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BookmarkGroupModel } from './bookmark.group.model';
import { StoryType } from 'src/app/story/models/story-type.enum';
var ɵ0 = function () { return BookmarkGroupModel; };
var BookmarkModel = /** @class */ (function () {
    function BookmarkModel() {
        this.type = StoryType.Bookmark;
        // favorites
        this.favorite = false;
        // legacy/orphaned content
        this.unavailable = false;
    }
    __decorate([
        Type(ɵ0),
        __metadata("design:type", Array)
    ], BookmarkModel.prototype, "group_access", void 0);
    return BookmarkModel;
}());
export { BookmarkModel };
export { ɵ0 };
